import { render, staticRenderFns } from "./DepotDocuments.vue?vue&type=template&id=0cc457af&"
import script from "./DepotDocuments.vue?vue&type=script&lang=js&"
export * from "./DepotDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports